import { Component, Inject, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef, MatRadioModule, MAT_DIALOG_DATA } from '@angular/material';
import { DialogProperties } from '../../utils/dialogProperties';
import { TypeDialog, EtatHoraire } from '../../utils/enumeration';
import { Statique } from '../../utils/statique';

@Component({
  selector: 'dialog-result',
  templateUrl: 'DialogResult.component.html',
  styleUrls: ['DialogResult.component.css']
})
export class DialogResult {

  action: String;
  motifRejet: String = '';
  dialogProperties: DialogProperties;
  typeDialogEnum = TypeDialog;
  listElement: Array<String>;
  elementError: String;
  errorMsg: String;
  confirmationMsg: String = null;
  Statique = Statique;
  EtatHoraire = EtatHoraire;

  constructor(public dialogRef: MatDialogRef<DialogResult>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.dialogProperties = data;

    if (this.dialogProperties.confirmationMsg !== null) {
      this.confirmationMsg = this.dialogProperties.confirmationMsg;
    }

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/material-design/DialogResult.component.ts